export default __webpack_public_path__ + "static/media/img_sent_message.659e6466.png";